import { isOwnerOrSupport } from 'shared/helpers/matchers/checkUserType';

export const converterCountsAccess = (userType, materialCountRequired) =>
  isOwnerOrSupport(userType) && materialCountRequired;
